// ** React Imports
import { useState, useEffect, SyntheticEvent } from 'react'

import appInfo from '../../../configs/app-info';

import Box from '@mui/material/Box'
import Card from '@mui/material/Card'
import CardHeader from '@mui/material/CardHeader'
import Button from '@mui/material/Button'
import Typography from '@mui/material/Typography'
import CardContent from '@mui/material/CardContent'
import Grid, { GridProps } from '@mui/material/Grid';
import { styled, useTheme } from '@mui/material/styles'
import FormControl from '@mui/material/FormControl'
import TextField from '@mui/material/TextField'
import FormHelperText from '@mui/material/FormHelperText'
import CircularProgress from '@mui/material/CircularProgress'
import FormLabel from '@mui/material/FormLabel'
import {
    CardActions,
    Divider,
    IconButton,
    InputAdornment,
    Radio,
    RadioGroup,
    Tooltip,
    Fab,
    FormControlLabel
} from '@mui/material'

import Select from '@mui/material/Select'
import MenuItem from '@mui/material/MenuItem'
import InputLabel from '@mui/material/InputLabel'

import Dialog from '@mui/material/Dialog'
import DialogTitle from '@mui/material/DialogTitle'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import DialogActions from '@mui/material/DialogActions'

import { useNavigate } from "react-router-dom";
import { Controller, useForm } from 'react-hook-form'
import axios from 'axios'
import Swal from 'sweetalert2'

import Icon from '../../../components/icon';
import MsiDatagridDynamic from '../../../components/custom/MsiDatagridDynamic';
import apiUrl from '../../../configs/constant';


// Styled Grid component
const StyledGrid = styled(Grid)<GridProps>(({ theme }) => ({
    [theme.breakpoints.down('sm')]: {
        order: -1,
        display: 'flex',
        justifyContent: 'center'
    }
}))

// Styled component for the image
const Img = styled('img')(({ theme }) => ({
    right: 0,
    bottom: 8,
    width: 100,
    position: 'absolute',
    [theme.breakpoints.down('sm')]: {
        width: 200,
        position: 'static'
    }
}))

export default function Index() {
    const userData = JSON.parse(localStorage.getItem('user')!)
    const user = userData.data
    const token = userData.token

    // ** State
    const [listData, setListData] = useState<any[]>([])
    const [loading, setLoading] = useState<boolean>(false)

    useEffect(() => {
        getData()
    }, [])

    const navigate = useNavigate();

    const getData = () => {
        setListData([])
        Swal.fire({
            title: 'Now loading',
            allowEscapeKey: false,
            allowOutsideClick: false,
            didOpen: () => {
                Swal.showLoading()
            }
        })

        const url = apiUrl.apiUrl + '/mm/konversi-satuan/list'
        axios
            .get(url, {
                params: {},
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    const data = response.data.data
                    setListData(data)
                    Swal.close()
                } else {
                    Swal.fire({
                        title: 'Pemberitahuan',
                        text: response.data.message,
                        icon: 'error'
                    })
                }
            })
    }


    const handleEdit = (row: any) => {
        navigate('/mm/konversi-satuan/detail/' + row.id)
    };

    const handleDelete = (row: any) => {
        Swal.fire({
            title: 'Konfirmasi',
            text: 'Apakah anda ingin hapus data ini ?',
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#337ab7',
            cancelButtonColor: '#ffc107',
            confirmButtonText: 'Hapus'
        }).then(result => {
            if (result.isConfirmed) {
                Swal.fire({
                    title: 'Now loading',
                    allowEscapeKey: false,
                    allowOutsideClick: false,
                    didOpen: () => {
                        Swal.showLoading()
                    }
                })

                const url = apiUrl.apiUrl + '/mm/konversi-satuan/delete/' + row.id
                axios
                    .delete(url, {
                        headers: {
                            Authorization: `Bearer ${token}`,
                        },
                    })
                    .then(response => {
                        if (response.data.success) {
                            Swal.fire({
                                title: 'Pemberitahuan',
                                text: response.data.message,
                                icon: 'success',
                                timer: 1000,
                                timerProgressBar: true,
                                willClose: () => {
                                    getData()
                                }
                            })
                        } else {
                            Swal.fire({
                                title: 'Pemberitahuan',
                                text: response.data.message,
                                icon: 'error'
                            })
                        }
                    })
                    .catch(error => {
                        Swal.fire({
                            title: 'Pemberitahuan',
                            text: error.message,
                            icon: 'error'
                        })
                    })
            }
        })
    };

    return (
        <Grid container spacing={3}>
            <Grid item xs={12}>
                <div className={'content-block dx-card'}>
                    <Box
                        sx={{
                            width: '100%',
                            display: 'flex',
                            flexWrap: 'wrap',
                            alignItems: 'center',
                            justifyContent: 'space-between'
                        }}
                    >
                        <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center' }}>
                            <CardHeader title='MASTER KONVERSI SATUAN' />
                        </Box>
                        <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', mr: 2 }}>
                            <Fab color='primary' size='medium' onClick={() => navigate('/mm/konversi-satuan/add')}
                            >
                                <Icon icon='mdi:plus' fontSize={35} color='white' />
                            </Fab>
                        </Box>
                    </Box>
                    <Divider />
                    {loading ? (
                        <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'center', margin: 10 }}>
                            <CircularProgress disableShrink sx={{ mt: 6, height: '100%' }} />
                        </Grid>
                    ) : (
                        <MsiDatagridDynamic key={1} data={listData} title='MASTER KONVERSI SATUAN' hiddenColumns={["id", "mmsatuan_id", "mmsatuan_tujuan_id"]} onEditRow={handleEdit} onDeleteRow={handleDelete} />
                    )}
                </div>
            </Grid>
        </Grid>
    )
}
